const dataLayer = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

const getGeolocation = async () => {
  const getCoordinates = (position) => {
    const location = position.coords.latitude + "," + position.coords.longitude;

    return location;
  };

  if ("geolocation" in navigator) {
    const geolocationPosition = await new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (position) => resolve(getCoordinates(position)),
        (error) => resolve(console.error("Geolocation Error: ", error.message))
      );
    });

    return geolocationPosition;
  }
};

export const Datalayer = {
  async onPageLoad(userId) {
    const referrer = document.referrer || undefined;
    const page = window.location.pathname;
    const url = window.location.href;
    const title = document.title;

    const global = {
      event: "global",
      userID: userId,
      dimension1: undefined,
    };

    dataLayer(global);

    const pageView = {
      event: "pageView",
      location: url,
      page: page,
      referrer: referrer,
      title: title,
    };

    dataLayer(pageView);
  },
  onClick(category, label, step) {
    const event = {
      event: "event",
      eventCategory: `casadosaber:${category}`,
      eventAction: `clique:botao:${step}`,
      eventLabel: label,
    };

    dataLayer(event);
  },
  onFill(category, label, step) {
    const event = {
      event: "event",
      eventCategory: `casadosaber:${category}`,
      eventAction: `preencheu:${step}`,
      eventLabel: label,
    };

    dataLayer(event);
  },
  onCheck(category, label) {
    const event = {
      event: "event",
      eventCategory: `casadosaber:${category}`,
      eventAction: `interacao:checkbox`,
      eventLabel: label,
    };

    dataLayer(event);
  },
  onCallback(label, userId = undefined) {
    const event = {
      event: "event",
      eventCategory: "casadosaber:checkout",
      eventAction: "cadastro:callback",
      eventLabel: label,
      userId: userId,
    };
    dataLayer(event);
  },
  onSignupCallback(label, userId) {
    const event = {
      event: "event",
      eventCategory: "casadosaber:cadastro_explore",
      eventAction: "cadastro_explore:callback",
      eventLabel: label,
      userId,
    };
    dataLayer(event);
  },
  onLoginCallback(label, userId) {
    const event = {
      event: "event",
      eventCategory: "casadosaber:login_explore",
      eventAction: "login_explore:callback",
      eventLabel: label,
      userId,
    };
    dataLayer(event);
  },
};

export default Datalayer;
